import { TPropsWithChildren } from '@ftd/types'
import { createTheme, MantineProvider as MantineProviderMantine } from '@mantine/core'

const theme = createTheme({})

export const MantineProvider: TPropsWithChildren = ({ children }) => (
  <MantineProviderMantine theme={theme}>{children}</MantineProviderMantine>
)
